import React from "react";
import "../navigation/Nav.css";
import NavItems from "./NavItems";

const Nav = () => {
  return <NavItems />;
};

export default Nav;
